$(document).ready(function(){

	$('.btn--print').on('click', function(e){
		$('details').addClass('open').prop('open', true).triggerHandler('open.details');
		$('details summary').attr('aria-expanded', true);
		$('details .content').css({'opacity':1, 'height':'auto'});
		setTimeout(function(){
			window.print();
			return false;
		},300);
	});

});